import React, { Fragment, memo } from 'react'
import PropTypes from 'prop-types'
import BlurCont from 'Layout/BlurCont'
import SvgIcon from 'Components/SvgIcon'
import { ReadMoreBox } from 'Layout'
// import { SITE_NAME } from 'Config/config'
// import { formatPhoneNumber } from 'Utils/inputUtils'
import Medias from './components/Medias'
import { OpenHouse, BrokrageAndMLS } from '../index.js'
import {
  _ReadMoreContainer, _MediaContainer, _VirtualTourBtn,
  _VirtualTourTitle, _VirtualTourSvg, _OpenHouseTitle,
  // _FeatureListingAgent,
  // _FeatureListingAgentInfo,
  // _FeatureListingAgentName,
} from './styles'


// const featureListingEmailCta = ({
//   featureListingAgent,
//   listing,
// }) => (
//   <a
//     href={
//       `mailto:${featureListingAgent.email}?` +
//       `subject=Question about your listing ${listing.title} from ${SITE_NAME}.ca` +
//       `&body=Hi ${featureListingAgent.name}%0D%0A%0D%0A` +
//       `I saw your listing ${listing.title} on ${SITE_NAME}.ca and would like to talk with you about it.%0D%0A` +
//       'Please contact me.%0D%0A%0D%0A' +
//       'Thank you'
//     }
//     alt="email agent"
//   >
//     Ask a question
//   </a>
// )


export const Description = ({
  listing,
  listingIsLocked,
  googleAnalyticsEvent,
  listingInfoHidden,
  listingPhotoHidden,
  componentName,
  isMobileApp,
  openHouses,
}) =>
  // const featuredListingAgent = listing?.featured_listing_agent
  (
    <Fragment>
      <_ReadMoreContainer name={componentName}>
        <ReadMoreBox
          title="Description"
          body={
            listingInfoHidden
              ? 'This listing’s details are not available to the public.'
              : (listing && listing.ad_text)
          }
          // bodyClass={}
          bodyMaxHeight={116}
          extraContent={
            !listingInfoHidden && listing && (
              <_MediaContainer>
                <Medias title={listing.title} medias={listing.medias} />
              </_MediaContainer>
            )
          }
          defaultShow={!!(listing && listing.featured)}
          readMoreToggle={() => {
            googleAnalyticsEvent({
              category: 'listing',
              action: '[Read More Click]',
            })
          }}
          isLocked={!listingInfoHidden && listingIsLocked}
        />
        <BrokrageAndMLS listing={listing} isLocked={listingIsLocked} />

        {/* {
          featuredListingAgent &&
            <_FeatureListingAgent>
              <_FeatureListingAgentInfo>
                <span>Listed by</span>
                <_FeatureListingAgentName>{featuredListingAgent.name || ''}</_FeatureListingAgentName>
                <div>{featuredListingAgent.title || 'Sales Representative'}</div>
                <div>{featuredListingAgent.email || ''}</div>

                <div>{featuredListingAgent.phone ? formatPhoneNumber(featuredListingAgent.phone) : ''}</div>
              </_FeatureListingAgentInfo>


            </_FeatureListingAgent>
        } */}

        {/* only if out backend virtual tour does not exist but thrid party exist */}
        {
          !(listingPhotoHidden || listingInfoHidden) && listing &&
          !(listing.medias && (listing.medias.MPEmbed || listing.medias.Matterport)) &&
          listing.tour_url && (
            <BlurCont blur={listingIsLocked}>
              <_VirtualTourBtn
                data-test-id="virtualTourBtn"
                alt={`Go ${listing.title} virtual tour`}
                openNewTab
                to={listing.tour_url}
                rel="noreferrer nofollow"
                onClick={() => {
                  googleAnalyticsEvent({
                    category: 'listing',
                    action: '[Virtual Tour Button Click]',
                  })
                }}
              >
                <_VirtualTourTitle>Take a look inside</_VirtualTourTitle>
                <_VirtualTourSvg>
                  <SvgIcon name="#icon-virtual-tour" width={20} height={20} />
                  <div>Start virtual tour</div>
                </_VirtualTourSvg>
              </_VirtualTourBtn>
            </BlurCont>
          )}

      </_ReadMoreContainer>
      {
        !isMobileApp && openHouses?.length > 0 && (
          <div>
            <_OpenHouseTitle>Open House Times</_OpenHouseTitle>
            <OpenHouse listing={listing} isMobileApp={isMobileApp} googleAnalyticsEvent={googleAnalyticsEvent} />
          </div>
        )
      }
    </Fragment>
  )


Description.propTypes = {
  listing: PropTypes.shape({
    ad_text: PropTypes.string,
    featured: PropTypes.number,
    id: PropTypes.number,
    title: PropTypes.string,
    medias: PropTypes.oneOfType([
      PropTypes.shape({
        Matterport: PropTypes.shape({}),
        MPEmbed: PropTypes.shape({}),
      }),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
    tour_url: PropTypes.string,
    featured_listing_agent: PropTypes.shape({}),
  }),
  openHouses: PropTypes.arrayOf(PropTypes.shape({})),
  listingIsLocked: PropTypes.bool,
  listingInfoHidden: PropTypes.bool,
  listingPhotoHidden: PropTypes.bool,
  googleAnalyticsEvent: PropTypes.func,
  componentName: PropTypes.string,
  isMobileApp: PropTypes.bool,
}

export default memo(Description)
